import React, { useEffect, useState } from "react";
import { Button, Container } from "@material-ui/core";
import { useNavigate } from "react-router";
import moment from 'moment';
import styles from "../calendar.module.scss";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import timezone from "dayjs/plugin/timezone";
import * as Popover from "@radix-ui/react-popover";
import { RescheduleDialogStep1, RescheduleDialogStep2 } from "../../../components/DialogComponent/SupplyDataDialog";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

function getTaskTitles(selectedAppointment) {
  const taskTitles = [];
  const seenTitles = new Set();

  for (const shiftId in selectedAppointment?.tasks) {
    const shift = selectedAppointment?.tasks[shiftId];
    if (shift && Array.isArray(shift?.tasksList)) {
      shift?.tasksList?.forEach((task) => {
        if (task.title && !seenTitles.has(task?.title)) {
          seenTitles.add(task?.title);
          taskTitles.push(task?.title);
        }
      });
    }
  }

  return taskTitles;
}

const getStatusTag = (cellData, settingsData, isMobile, alerts, isCheckInShow = false) => {
    const timeZone = "America/New_York";
    const calendarTimezone = cellData?.calendarTimezone || timeZone;

    const currentDate = dayjs().tz(calendarTimezone).startOf("day");
    const appointmentDateTime = cellData?.datetime || cellData?.appointmentDateTime;
    const appointment = dayjs(appointmentDateTime).tz(calendarTimezone);
    const appointmentDay = appointment.clone().startOf("day");

    const isToday = appointmentDay.isSame(currentDate, "day");

    let status = styles.white;

    if (alerts === "allAlerts") {
      status = isToday ? styles.statusYellow : styles.fadYellow;
    } else if (alerts === "todayAlerts" && isToday) {
      status = styles.statusYellow;
    }

    const now = dayjs().tz(calendarTimezone);
    const minutesSinceAppointment = now.diff(appointment, "minute");

    if (cellData) {
      const timeSheetData = cellData;
      const secsToGet = timeSheetData?.checkInDateTime || timeSheetData?.createdAt;

      let seconds;
      if (secsToGet?.toJSON) {
        seconds = secsToGet.toJSON()["seconds"];
      } else if (secsToGet) {
        seconds = secsToGet["seconds"];
      }

      const checkIn = dayjs.unix(seconds).tz(calendarTimezone);
      const minutesLate = checkIn.diff(appointment, "minute");

      const now = moment();
      const isFuture = moment(appointmentDateTime).isAfter(now);
      const hasCheckIn = !!timeSheetData?.checkInDateTime;

      if (!hasCheckIn) {
        if (isFuture) {
          status =
            alerts === "allAlerts"
              ? styles.statusYellow
              : alerts === "noAlerts"
              ? styles.white
              : alerts === "todayAlerts" && isToday
              ? styles.statusYellow
              : status;
        } else {
          status =
            alerts === "allAlerts"
              ? isToday
                ? styles.statusRed
                : styles.fadRed
              : alerts === "noAlerts"
              ? styles.white
              : alerts === "todayAlerts" && isToday
              ? styles.statusRed
              : status;
        }
      } else if (hasCheckIn && minutesLate <= 5) {
        status =
          alerts === "allAlerts"
            ? isToday
              ? styles.statusGreen
              : styles.fadGreen
            : alerts === "noAlerts"
            ? styles.white
            : alerts === "todayAlerts" && isToday
            ? styles.statusGreen
            : status;
      } else if (hasCheckIn && minutesLate > 5) {
        status =
          alerts === "allAlerts"
            ? isToday
              ? styles.statusOrange
              : styles.fadOrange
            : alerts === "noAlerts"
            ? styles.white
            : alerts === "todayAlerts" && isToday
            ? styles.statusOrange
            : status;
      }
    }

    return (
      <>
        <div
          style={{
            position: "absolute",
            left: "-10px",
            top: "5px",
            bottom: "0",
            width: "4px",
          }}
          className={status}
        ></div>
      {isCheckInShow && cellData?.checkInDateTime && (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
          }}
        >
          <span>CheckIn : </span>
          <span
            style={{
              color: "#484848",
              fontWeight: "600",
              marginRight: "2px",
              marginLeft: "3px",
            }}
          >
            {moment
              .unix(cellData?.checkInDateTime?.seconds)
              .tz(cellData?.apoointmentDetails?.calendarTimezone)
              .format(
                settingsData?.timeFormat === "24hrs" ? "HH:mm" : "h:mm a"
              )}
          </span>
          (
          <div
            className={`${styles.stausCircle} ${status} ${
              isMobile ? "mr-10" : ""
            }`}
          ></div>
          )
        </span>
      )}
      </>
    );
};

const ShiftDetails = ({ selectedAppointment }) => {
    const titles = selectedAppointment ? getTaskTitles(selectedAppointment) : [];
    const itemsPerColumn = Math.ceil(titles.length / 4);

    const columns = [];
    for (let i = 0; i < 4; i++) {
        const columnItems = titles.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn);
        columns.push(columnItems);
    }

    return (
        <div className="detail-item">
            <div className="detail-label dark:text-white">Shift Details</div>
            <div className="detail-value dark:text-[#6B7280]">
                <div className="shift-grid">
                    {titles.map((title, index) => (
                        <div
                            key={index}
                            className="mv-5 ml-0 mr-5"
                            style={{lineHeight:"20px"}}
                        >
                            {title}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
  
export function AppointmentModal({
    selectedAppointment,
    isMobile,
    isLandscape,
    clientDetails,
    employeeDetails,
    appoinments,
    auth,
    setIsModalOpen,
    setCancelAppt,
    settingsData,
    alerts,
    create
}) {

    const navigate = useNavigate();    
    const getNowInTimezone = (timeZone) => {
      return new Date(
        new Date().toLocaleString("en-US", { timeZone })
      );
    };

    const tz = selectedAppointment?.apoointmentDetails?.calendarTimezone || "America/New_York";
    const nowInAppointmentTZ = getNowInTimezone(tz);
    const [showRecurringDialog, setShowRecurringDialog] = useState(false);
    const [showSomeDialog, setShowSomeDialog] = useState(false);
    const [recurringOption, setRecurringOption] = useState(""); 

    const checkInTime = selectedAppointment?.checkInDateTime?.seconds 
    ? moment.unix(selectedAppointment.checkInDateTime.seconds).tz(selectedAppointment?.apoointmentDetails?.calendarTimezone).format("hh:mm a") : null;
  
    const checkOutTime = selectedAppointment?.checkOutDateTime?.seconds 
    ? moment.unix(selectedAppointment.checkOutDateTime.seconds).tz(selectedAppointment?.apoointmentDetails?.calendarTimezone).format("hh:mm a") : null;

    const clientId = selectedAppointment.apoointmentDetails?.clientId ? selectedAppointment.apoointmentDetails?.clientId : selectedAppointment?.clientId;
    const clientData = clientDetails?.find((client) => client.id === clientId);

    const createdBy = selectedAppointment.apoointmentDetails.scheduledBy;
    const userData = employeeDetails?.find(
        (emp) => emp.email === createdBy
    );

    const inactiveEmp = employeeDetails?.find((emp)=> emp?.userId === selectedAppointment?.userId);
    const inputDate = new Date(selectedAppointment.apoointmentDetails.date);
    const formattedDate = inputDate.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    });
    const month = inputDate.toLocaleString("en-US", { month: "short" });
    const day = inputDate.getDate();
    const taskArr = Object.keys(selectedAppointment.tasks);
    const shiftName = selectedAppointment?.tasks[taskArr[0]]?.title;

   const findMatchingAppointments = () => {
      if (!selectedAppointment) return [];

      const details = selectedAppointment.apoointmentDetails;

      if (details.type === "Recurring Appointment") {
          return appoinments?.filter((appointment) => {
              const d = appointment?.apoointmentDetails;

              return (
                  d.appointmentTypeID === details.appointmentTypeID &&
                  d.frequency === details.frequency &&
                  d.duration === details.duration &&
                  d.clientId === details.clientId &&
                  appointment.userId === selectedAppointment.userId &&
                  appointment.companyId === selectedAppointment.companyId &&
                  appointment.shiftId === selectedAppointment.shiftId &&
                  d.shiftName === details.shiftName &&
                  d.time === details.time &&
                  d.endTime === details.endTime
              );
          });
      }

      return [selectedAppointment];
  };

  const getFutureAppointments = (appointments) => {
    return appointments?.filter(a => {
      const details = a.apoointmentDetails;
      const timeZone = details?.calendarTimezone || "America/New_York";

      const nowInTZ = getNowInTimezone(timeZone);

      // const start = new Date(details.appointmentDateTime);
      const end = new Date(new Date(`${details?.date} ${details?.endTime}`).toLocaleString("en-US", { timeZone }));

      const hasCheckIn = !!a?.checkInDateTime;

      if (end < nowInTZ) return false;

      if (hasCheckIn) return false;

      return true;
    });
  };

    const matchAppointmentsData = findMatchingAppointments();
    const futureAppointments = getFutureAppointments(matchAppointmentsData);
    const matchingAppointments = futureAppointments?.sort((a, b) =>new Date(a?.apoointmentDetails?.appointmentDateTime) - new Date(b?.apoointmentDetails?.appointmentDateTime));
    const matchedAppointmentList = matchAppointmentsData?.sort((a, b) =>new Date(a?.apoointmentDetails?.appointmentDateTime) - new Date(b?.apoointmentDetails?.appointmentDateTime));

    const currentDateTime = moment().utc();
    const appointmentDateTime = moment.utc(
      `${selectedAppointment?.apoointmentDetails?.date} ${selectedAppointment?.apoointmentDetails?.time}`, 
      "MMMM DD, YYYY hh:mm A" 
    );
    const isDateValid = appointmentDateTime.isSameOrAfter(currentDateTime);
    
    const timeZones = [
        { label: "EDT - Eastern", value: "America/New_York" },
        { label: "CDT - Central", value: "America/Chicago" },
        { label: "MDT - Mountain", value: "America/Denver" },
        { label: "PDT - Pacific", value: "America/Los_Angeles" }
    ];

    // const isCancelable = selectedAppointment?.source !== "proteams" || // Must be from proteams
    //                     inactiveEmp?.status === false || // Employee must be active
    //                     checkInTime !== null || // Disable if user has checked in (i.e., checkInTime is NOT null)
    //                     (isDateValid === false && selectedAppointment?.source === "proteams" && inactiveEmp?.status !== false && checkInTime === null ? false : !isDateValid)
    const startDateTime = new Date(`${selectedAppointment?.apoointmentDetails?.date} ${selectedAppointment?.apoointmentDetails?.time}`);
    let endDateTime = new Date(`${selectedAppointment?.apoointmentDetails?.date} ${selectedAppointment?.apoointmentDetails?.endTime}`);
    
    if (endDateTime <= startDateTime) {
      endDateTime.setDate(endDateTime.getDate() + 1);
    }

    const isProteams = selectedAppointment?.source === "proteams";
    const isActiveEmp = inactiveEmp?.status !== false;
    const hasCheckIn = checkInTime !== null;
    const hasCheckOut = checkOutTime !== null;
    const isBeforeEnd = nowInAppointmentTZ < endDateTime;

    const isCancelable = isProteams && isActiveEmp && !hasCheckIn && isBeforeEnd;
    const isReschedule = isProteams && isActiveEmp && (!hasCheckIn || (hasCheckIn && !hasCheckOut && isBeforeEnd));

    useEffect(() => {
      if (!appoinments || appoinments.length === 0) return;

      if (auth?.updateAppointmentData?.matchingAppointments) {
        const matched = findMatchingAppointments();
        const future = getFutureAppointments(matched);
        const sortedAppointments = future?.sort((a, b) => new Date(a?.apoointmentDetails?.appointmentDateTime) - new Date(b?.apoointmentDetails?.appointmentDateTime));
        auth.setUpdateAppointmentData({matchingAppointments: sortedAppointments});
      }
    }, [appoinments]);

    const handleConfirm = () => {
      setShowRecurringDialog(false);

      if (recurringOption === "some") {
        setShowSomeDialog(true);
        return;
      }

      navigate(`/operations/appoinmentSchedule/${selectedAppointment?.id}`, {state: { mode: recurringOption },});
      auth.setUpdateAppointmentData({ matchingAppointments });
      setIsModalOpen(false);
      auth.setIsExpanded(false);
    };

    const handleConfirmStep2 = () => {
      setShowSomeDialog(false);
      
      auth.setUpdateAppointmentData({ matchingAppointments });
      auth.setIsExpanded(false);
      setIsModalOpen(false);
      navigate(`/operations/appoinmentSchedule/${selectedAppointment?.id}`, {state: { mode: "some" },});
    };

    return (
      <>
        <div>
          <Container
            style={{ position: "relative" }}
            className="containersAppt"
          >
            <div className="stickyHeader dark:bg-[#1A1F2C]">
              <div className="d-flex flex-space-between flex-center">
                <div className="flex-start">
                  <Button
                    className="modal-close link"
                    onClick={() => {
                      setIsModalOpen(false);
                      auth.setUpdateAppointmentData({});
                    }}
                  >
                    Close Window
                  </Button>
                </div>
                {create !== true && (
                  <div className="d-flex">
                    <div className="mr-20">
                      <Popover.Root>
                        <Popover.Trigger asChild>
                            <span>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: isCancelable ? "#f62d51" : "gray",
                                color: "white",
                                boxShadow: "none",
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                marginTop:"12px"
                              }}
                              onClick={() => {
                                setCancelAppt(true);
                                auth.setEditAppointmentData({
                                  selectedAppointment,
                                });
                                auth.setUpdateAppointmentData({
                                  matchingAppointments,
                                });
                              }}
                              disabled={!isCancelable}
                            >
                              Cancel Appt
                            </Button>
                            </span>
                          </Popover.Trigger>
                          {!isCancelable && (
                            <Popover.Content className="max-w-xs p-8 bg-white border rounded shadow-lg">
                              <p className="text-sm">
                                You cannot cancel an appointment that has
                                already started. Please ask the employee to
                                punch out, or manually end the shift yourself.
                              </p>
                            </Popover.Content>
                          )}
                        </Popover.Root>
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: isReschedule ? "green" : "gray",
                          color: "white",
                          boxShadow: "none",
                          marginTop:"12px"
                        }}
                        onClick={() => {
                          if (selectedAppointment?.apoointmentDetails?.type === "Recurring Appointment") {
                            setShowRecurringDialog(true);
                          } else {
                            setIsModalOpen(false);
                            navigate(`/operations/appoinmentSchedule/${selectedAppointment?.id}`, {state: { mode: "this" },});
                            auth.setUpdateAppointmentData({ matchingAppointments });
                            auth.setIsExpanded(false);
                          }
                        }}
                        disabled={!isReschedule}
                      >
                        ReSchedule
                      </Button>
                    </div>
                  </div>
                )}
              </div>
              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#ddd",
                }}
                className="mb-20 mt-10"
              ></div>
            </div>

            <div>
              <div className="details-grid">
                <div className="details-column">
                  <div className="appointment-header">
                    <div class="date-icon">
                      <div class="date-icon-top-lines">
                        <div class="line">
                          <div class="inner-line"></div>
                        </div>
                        <div class="line">
                          <div class="inner-line"></div>
                        </div>
                        <div class="line">
                          <div class="inner-line"></div>
                        </div>
                      </div>
                      <div class="date-icon-day">{day}</div>
                      <div class="date-icon-month">{month}</div>
                    </div>

                    <div>
                      <h2 className="appointment-title dark:text-white">
                        {clientData?.clientName}
                      </h2>
                      <div className="d-flex flex-center">
                        <div className="appointment-datetime dark:text-[#6B7280]">
                          {formattedDate}
                          <br />
                          <span
                            className="dark:text-[#6B7280] text-[#484848]"
                            style={{ fontWeight: "600" }}
                          >
                            {settingsData?.timeFormat === "24hrs"
                              ? moment(
                                  selectedAppointment?.apoointmentDetails?.time,
                                  "h:mm A"
                                ).format("HH:mm")
                              : selectedAppointment?.apoointmentDetails
                                  ?.time}{" "}
                            -{" "}
                            {settingsData?.timeFormat === "24hrs"
                              ? moment(
                                  selectedAppointment?.apoointmentDetails
                                    ?.endTime,
                                  "h:mm A"
                                ).format("HH:mm")
                              : selectedAppointment?.apoointmentDetails
                                  ?.endTime}
                          </span>
                          <br />
                        </div>
                        <div className="appointment-datetime ml-20">
                          <span>
                            {selectedAppointment?.checkInDateTime && (
                              <>
                                {getStatusTag(
                                  selectedAppointment,
                                  settingsData,
                                  isMobile,
                                  alerts,
                                  true
                                )}
                              </>
                            )}
                            {selectedAppointment?.checkOutDateTime && (
                              <>
                                {" "}
                                <span>CheckOut : </span>
                                <span
                                  className="dark:text-[#6B7280] text-[#484848]"
                                  style={{ fontWeight: "600" }}
                                >
                                  {moment
                                    .unix(
                                      selectedAppointment?.checkOutDateTime
                                        ?.seconds
                                    )
                                    .tz(
                                      selectedAppointment?.apoointmentDetails
                                        ?.calendarTimezone
                                    )
                                    .format(
                                      settingsData?.timeFormat === "24hrs"
                                        ? "HH:mm"
                                        : "h:mm a"
                                    )}
                                </span>
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${
                      isMobile || isLandscape
                        ? "d-flex flex-direction-column"
                        : "d-flex"
                    }`}
                  >
                    <div className="detail-item">
                      <div className="detail-label dark:text-white">Phone</div>
                      <div className="detail-value dark:text-[#6B7280]">
                        {clientData?.contact?.[0]?.mobileNumber}
                      </div>
                    </div>
                    <div
                      className={`${
                        isMobile || isLandscape
                          ? "detail-item"
                          : "detail-item ml-25"
                      }`}
                    >
                      <div className="detail-label dark:text-white">Email</div>
                      <div className="detail-value dark:text-[#6B7280]">
                        {clientData?.contact?.[0]?.email}
                      </div>
                    </div>
                    <div
                      className={`${
                        isMobile || isLandscape
                          ? "detail-item"
                          : "detail-item ml-25"
                      }`}
                    >
                      <div className="detail-label dark:text-white">
                        Client Time Zone
                      </div>
                      <div className="detail-value dark:text-[#6B7280]">
                        {
                          timeZones?.find(
                            (item) => item.value === clientData?.timeZone
                          )?.label
                        }
                      </div>
                    </div>
                  </div>
                  <div className="detail-item">
                    <div className="detail-label dark:text-white">
                      Client Address
                    </div>
                    <div className="detail-value dark:text-[#6B7280]">
                      {selectedAppointment?.apoointmentDetails?.forms?.[0]?.values
                        ?.filter((item) =>
                          ["Address", "State", "City", "ZipCode"].includes(item.name)
                        )
                        ?.map((item) => {
                          if (item?.name === "Address") {
                            const unit = selectedAppointment?.apoointmentDetails?.unitNumber ?? selectedAppointment?.apoointmentDetails?.unitNumber?.trim();
                            return unit ? `${item?.value} ${unit}` : item?.value;
                          }
                          return item?.value || "N/A";
                        })
                        ?.join(", ")}
                    </div>
                  </div>
                  <ShiftDetails selectedAppointment={selectedAppointment} />
                </div>

                <div className="details-column right">
                  <div className="d-flex flex-space-between">
                    <div className="detail-item">
                      <div className="detail-label2 dark:text-white">
                        Appointment Type
                      </div>
                      <div className="detail-value2 dark:text-[#6B7280]">
                        {selectedAppointment.apoointmentDetails?.type}
                      </div>
                    </div>
                    <div className="detail-item ml-10" style={{ width: "50%" }}>
                      <div className="detail-label2 dark:text-white">
                        Employee Name
                      </div>
                      <div className="detail-value2 dark:text-[#6B7280]">
                        {selectedAppointment.apoointmentDetails?.calendar}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-space-between">
                    <div className="detail-item">
                      <div className="detail-label2 dark:text-white">
                        Shift Name
                      </div>
                      <div className="detail-value2 dark:text-[#6B7280]">
                        {selectedAppointment.apoointmentDetails?.shiftName ||
                          shiftName}
                      </div>
                    </div>
                    <div className="detail-item ml-10" style={{ width: "50%" }}>
                      <div className="detail-label2 dark:text-white">
                        Created By
                      </div>
                      <div className="detail-value2 dark:text-[#6B7280]">
                        {userData?.firstName}
                        {userData?.lastName}
                      </div>
                    </div>
                  </div>
                  <div className="detail-item">
                    <div className="detail-label2 dark:text-white">
                      Appointments
                    </div>
                    <div className="appointments-list dark:bg-gray-600">
                      {matchedAppointmentList?.map((apt, index) => (
                        <div key={index} className="appointment-item">
                          <div className="ml-10">
                            <span
                              className="dark:text-white text-[#7d7d7d]"
                              style={{ fontWeight: "500" }}
                            >
                              {settingsData?.timeFormat === "24hrs"
                                ? moment(
                                    apt.apoointmentDetails?.time,
                                    "h:mm A"
                                  ).format("HH:mm")
                                : apt.apoointmentDetails?.time}{" "}
                              on{" "}
                            </span>{" "}
                            <span
                              className="dark:text-white text-[#3c3c3c]"
                              style={{
                                fontSize: "14px",
                                fontWeight: "800",
                              }}
                            >
                              {apt.apoointmentDetails?.date}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>

        {showRecurringDialog && (
          <RescheduleDialogStep1 
            open={showRecurringDialog}
            onConfirm={handleConfirm}
            onClose={() => {setShowRecurringDialog(false); setIsModalOpen(false); auth.setUpdateAppointmentData({});}}
            recurringOption={recurringOption}
            setRecurringOption={setRecurringOption}
            selectedAppointment={selectedAppointment}
          />
        )}

        {showSomeDialog && (
          <RescheduleDialogStep2
            open={showSomeDialog}
            onConfirm={handleConfirmStep2}
            onClose={() => {setShowSomeDialog(false); setIsModalOpen(false); auth.setUpdateAppointmentData({});}}
          />
        )}
      </>
    );
};

export function AppointmentsDetailComponent({
    appointments,
    handleAppointmentOpen,
    appointmentRefs,
    empNames,
    clientName,
    settingsData,
    alerts
}) {
    const sortedDates = Object.keys(appointments)?.sort((a, b) => new Date(a) - new Date(b));

    return (
        <div>
            {sortedDates?.map((date) => {
                const filteredAppointments = appointments[date]?.filter(appointment => {
                    const clientFilter = clientName === "All" || appointment.clientId === clientName;
                    const empFilter = empNames === "All" || appointment.userId === empNames;
                    return clientFilter && empFilter;
                });

                if (filteredAppointments.length === 0) return null;

                return (
                    <div key={date} ref={(el) => (appointmentRefs.current[date] = el)} className="mb-30" style={{ scrollMarginTop: "85px" }}>
                        <div
                            className="d-flex flex-center pl-10 bg-[#eef5f9] dark:bg-gray-600 dark:text-white"
                            style={{
                                // backgroundColor: "#eef5f9",
                                height: "35px",
                                fontSize: "14px",
                                fontWeight: "500",
                            }}
                        >
                            {date}
                        </div>

                        {filteredAppointments?.sort((a, b) => {
                            const timeA = a.appointmentDateTime.slice(11, 16);
                            const timeB = b.appointmentDateTime.slice(11, 16);
                            return timeA.localeCompare(timeB);
                        }).map((appointment, index) => (
                            <React.Fragment key={index}>
                                <div
                                    style={{
                                        display: "flex",
                                        marginBottom: "10px",
                                        marginTop: "15px",
                                        position: "relative",
                                        marginLeft: "20px",
                                        marginRight: "5px",
                                        paddingLeft: "12px",
                                    }}
                                >
                                    {getStatusTag(appointment, null, null, alerts, false)}

                                    <div style={{ flex: 1 }}>
                                        <div
                                            className="mv-5"
                                            style={{
                                                color: "#078037",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                cursor:"pointer"
                                            }}
                                            onClick={() => handleAppointmentOpen(appointment)}
                                        >
                                            {appointment?.apoointmentDetails?.calendar}
                                        </div>
                                        <div className="dark:text-white">{appointment?.apoointmentDetails?.calendarTimezone}</div>
                                        <div
                                            className="mt-12"
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div className="mv-5 dark:text-white">
                                                {appointment?.apoointmentDetails?.forms?.[0]?.values?.filter((item) => item.name === "Shift Name")
                                                    ?.map((item) => item.value)} Shift
                                            </div>
                                            <div className="dark:text-[#6B7280]">{appointment?.apoointmentDetails?.duration} minutes</div>
                                        </div>
                                        <div className="mb-10 dark:text-[#6B7280]">
                                            {settingsData?.timeFormat === '24hrs' ? moment(appointment?.apoointmentDetails?.time, 'h:mm A').format('HH:mm') : appointment?.apoointmentDetails?.time} - {settingsData?.timeFormat === '24hrs' ? moment(appointment?.apoointmentDetails?.endTime, 'h:mm A').format('HH:mm') : appointment?.apoointmentDetails?.endTime}
                                        </div>
                                        <div className="d-flex">
                                        {appointment?.checkInDateTime && (
                                            <div style={{ color: "#8B8B8B", fontWeight: "600", marginRight: "5px"}}>
                                                {moment
                                                    .unix(appointment?.checkInDateTime?.seconds)
                                                    .tz(appointment?.apoointmentDetails?.calendarTimezone)
                                                    .format(settingsData?.timeFormat === "24hrs" ? "HH:mm" : "h:mm a")}
                                            </div>)}
                                        {appointment?.checkInDateTime && appointment?.checkOutDateTime && " - "}
                                        {appointment?.checkOutDateTime && (
                                            <div style={{ color: "#8B8B8B", fontWeight: "600", marginLeft: "5px"}}>
                                                {moment
                                                    .unix(appointment?.checkOutDateTime?.seconds)
                                                    .tz(appointment?.apoointmentDetails?.calendarTimezone)
                                                    .format(settingsData?.timeFormat === "24hrs" ? "HH:mm" : "h:mm a")}
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                </div>
                                {index < filteredAppointments.length - 1 && (
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "1px",
                                            backgroundColor: "#ddd",
                                        }}
                                        className="mv-20"
                                    ></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                );
            })}
        </div>
    );
};
